var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.875 36.5C28.54 36.5 36.375 28.665 36.375 19C36.375 9.33502 28.54 1.5 18.875 1.5C9.21002 1.5 1.375 9.33502 1.375 19C1.375 28.665 9.21002 36.5 18.875 36.5Z",
    stroke: "#EDFFED",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4682 14.5208H22.0766C22.2245 14.5208 22.3446 14.4076 22.3446 14.2682V12.7526C22.3446 12.6132 22.2245 12.5 22.0766 12.5H20.4682C18.8427 12.5 17.5195 13.7463 17.5195 15.2786V17.0468H15.6431C15.4951 17.0468 15.375 17.1599 15.375 17.2994V18.8149C15.375 18.9544 15.4951 19.0675 15.6431 19.0675H17.5195V24.3721C17.5195 24.5115 17.6396 24.6247 17.7876 24.6247H19.3959C19.5439 24.6247 19.664 24.5115 19.664 24.3721V19.0675H21.5405C21.6557 19.0675 21.7581 18.9978 21.7951 18.8948L22.3312 17.3792C22.3586 17.3024 22.3446 17.2175 22.2942 17.1513C22.2433 17.0857 22.1629 17.0468 22.0766 17.0468H19.664V15.2786C19.664 14.8608 20.0248 14.5208 20.4682 14.5208Z",
    fill: "#EDFFED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.c26c75f23465e382f0384de69ba56667.svg";
export { ForwardRef as ReactComponent };